export default __webpack_public_path__ + "static/media/IBMFolderSharedActive.f74fdc7c.svg";